import { CHART_MARGIN, Y_AXIS_TICK_WIDTH } from '../constants/utils';

const calculateCartesianGridWidth = (chartWidth: number) => {
  // subtract custom chart margins
  // subtract custom Y axis width
  return (
    chartWidth - CHART_MARGIN.left - CHART_MARGIN.right - Y_AXIS_TICK_WIDTH
  );
};

export default calculateCartesianGridWidth;
